import Router from "vue-router";
import Vue from "vue";
import landingPage from "@/views/landing.vue";
import fillForm from "@/views/identification/identification.vue";
import loginPage from "@/views/login.vue";
import viewFormPage from "@/views/identification/viewForm.vue";
import viewAllCourtsPage from "@/views/identification/viewCourts.vue";
import editFormPage from "@/views/identification/editForm.vue";
import viewAllFormsPage from "@/views/identification/viewForms.vue";
import viewOrgsComponent from "@/views/organizations.vue";
import viewAllUsersComponent from "@/views/users.vue";
import viewUserComponent from "@/components/users/userComponent.vue";
import viewAux from "@/views/AuxiliarView.vue";
import viewRoles from "@/views/Roles.vue";
import viewPermissions from "@/views/permissions.vue";
import viewReports from "@/views/reports.vue";
import publicForm from "@/views/publicForm.vue";
import guides from "@/views/guidesView.vue";
import manageGuides from "@/views/manageGuides.vue";
import charts from "@/views/charts.vue";
import manageReports from "@/views/manageReports.vue";
import report from "@/views/report.vue";
import { getWithExpiry } from "@/utils/apiRequest";

Vue.use(Router);

var router = new Router({
  routes: [
    { path: "/", name: "Landing", component: landingPage },
    {
      path: "/identificacion",
      name: "identification",
      component: fillForm,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/login",
      name: "login",
      component: loginPage,
      meta: {
        guest: true,
      },
    },
    {
      path: "/public/:id",
      name: "public",
      component: publicForm,
      meta: {
        hideNavbar: true,
      }
    },
    {
      path: "/guias",
      name: "guias",
      component: guides,
      meta: {},
    },
    {
      path: "/guias/administrar",
      name: "guideManage",
      component: manageGuides,
      meta: { requiresAuth: true },
    },
    {
      path: "/registros",
      name: "registros",
      component: viewAllFormsPage,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/registros/:id",
      name: "registro",
      component: editFormPage,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/cortes",
      name: "cortes",
      component: viewAllCourtsPage,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/inventario",
      name: "inventario",
      component: viewReports,
      meta: {},
    },
    {
      path: "/reportes",
      name: "reportes",
      component: manageReports,
      meta: { requiresAuth: true },
    },
    {
      path: "/reporte/:id",
      name: "reporte",
      component: report,
      meta: { requiresAuth: true, hideNavbar: true },
    },
    {
      path: "/cortes/:id",
      name: "corte",
      component: viewFormPage,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/usuarios/",
      name: "usuarios",
      component: viewAllUsersComponent,
      meta: {
        requiresAuth: true,
        is_admin: true,
      },
    },
    {
      path: "/usuarios/:id",
      name: "usuario",
      component: viewUserComponent,
      meta: {
        requiresAuth: true,
        is_admin: true,
      },
    },
    {
      path: "/organizaciones/",
      name: "organizaciones",
      component: viewOrgsComponent,
      meta: {
        requiresAuth: true,
        is_admin: true,
      },
    },
    {
      path: "/auxiliares/",
      name: "auxiliares",
      component: viewAux,
      meta: {
        requiresAuth: true,
        is_admin: true,
      },
    },
    {
      path: "/roles/",
      name: "roles",
      component: viewRoles,
      meta: {
        requiresAuth: true,
        is_admin: true,
      },
    },
    {
      path: "/permisos/",
      name: "permisos",
      component: viewPermissions,
      meta: {
        requiresAuth: true,
        is_admin: true,
      },
    },
    {
      path: "/graficos",
      name: "graficos",
      component: charts,
      meta: {
        requiresAuth: true,
      },
    },
  ],
  mode: "history",
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (getWithExpiry("jwt") == null) {
      next({
        path: "/login",
        params: { nextUrl: to.fullPath },
      });
    } else {
      let user = JSON.parse(getWithExpiry("user"));
      if (user == null) {
        next({ name: "Landing" });
      }
      if (to.matched.some((record) => record.meta.is_admin)) {
        if (user.roles.toUpperCase().includes("ADMIN")) {
          next();
        } else {
          next({ name: "Landing" });
        }
      } else if (to.matched.some((record) => record.meta.is_auxiliar)) {
        if (user.permissions.toUpperCase().includes("AUXILIAR")) {
          next();
        } else {
          next({ name: "Landing" });
        }
      } else {
        next();
      }
    }
  } else if (to.matched.some((record) => record.meta.guest)) {
    if (getWithExpiry("jwt") == null) {
      next();
    } else {
      next({ name: "Landing" });
    }
  } else {
    next();
  }
});

export default router;
